import { Actualizador } from "./Actualizador";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { InvestigacionesService } from "../../../../servicesBackend/investigaciones.service";
import { EnvioDTO, InvestigacionDTO } from "@DTOS";

export interface ResultadoActualizacionEnvio {
    investigacion: InvestigacionDTO;
    envio: EnvioDTO;
}

export class EnvioActualizador extends Actualizador<ResultadoActualizacionEnvio> {
    constructor(private investigacionesService: InvestigacionesService) {
        super();
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.envio != null;
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<ResultadoActualizacionEnvio> {
        const investigacionClon = investigacion.clon();
        let envioDTO: EnvioDTO;
        if (datos.envio!.id === 0) {
            envioDTO = await this.investigacionesService.agregarEnvio(investigacionClon, datos.envio!);
        } else {
            envioDTO = await this.investigacionesService.actualizarEnvio(investigacionClon, datos.envio!);
        }

        const grupoEncontrado = investigacionClon.grupos.find(grupo => grupo.id === datos.envio!.grupoId)!;
        if (datos.envio!.id === 0) {
            grupoEncontrado.envios.push(envioDTO);
        } else {
            grupoEncontrado.envios = grupoEncontrado?.envios
                .map(envio => envio.id === datos.envio!.id? envioDTO : envio);
        }

        return {
            investigacion: investigacionClon,
            envio: envioDTO
        };
    }
}
